// extracted by mini-css-extract-plugin
export default {"turn_control":"TurnControl_turn_control__nVoU-"};